import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ToastHost from "./components/ToastHost";

import Home from "./pages/Home";

export default function App() {
  return (
    <BrowserRouter>
      <ToastHost>
        <div className="appShell">
          <Navbar />
          <main className="appMain">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ToastHost>
    </BrowserRouter>
  );
}